import { LOCALE_HAS_COMMUNITY_SITE } from '@hhgtech/hhg-components/constants'
import { Box, Flex } from '@mantine/core'

import { AdBlock } from 'components/molecules/adBlock'
import { CommunityBanner } from 'components/molecules/communityBanner'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { ArticleApi, TogetherTopic } from 'interfaces/types'
import { DueDateInfoApi } from 'interfaces/types/DueDate'

import { DueDateNavResultTarget } from './desktopNavResult'
import GuideAndSupportArticles from './guideAndSupportArticles'

type Props = {
  adUnitPath: string
  topics: TogetherTopic[]
  suggestedArticles: ArticleApi[]
  titleArticle?: string
  descriptionArticle?: string
  dueDate?: Date
  sponsorBanner: DueDateInfoApi['sponsor_banner'] | undefined
}

const GuideAndSupport = ({
  adUnitPath,
  dueDate = new Date(),
  topics = [],
  suggestedArticles,
  titleArticle,
  descriptionArticle,
  sponsorBanner,
}: Props) => {
  const isMobile = useIsMobile()
  const { locale } = useRouterExtend()
  const hasArticlesSection = !!suggestedArticles.length
  const hasSponsorBanner = !!sponsorBanner?.image
  const hasCommunityBanner =
    LOCALE_HAS_COMMUNITY_SITE.includes(locale) && !!topics.length
  const renderedAdsAndCommunitySection = (
    <Flex direction="column" gap={24} px={isMobile ? 16 : 0}>
      {hasCommunityBanner && (
        <CommunityBanner topics={topics} dueDate={dueDate} isRevamp />
      )}
      {sponsorBanner?.image && (
        <Box>
          <a
            href={
              sponsorBanner?.further_result?.link?.url || sponsorBanner?.image
            }
          >
            <img
              src={sponsorBanner?.image}
              alt="Sponsor Banner"
              loading="lazy"
              className="w-full rounded-lg cursor-pointer"
            />
          </a>
        </Box>
      )}
      <div className="top-ad">
        <AdBlock
          adUnitPath={adUnitPath}
          size={[
            [300, 250],
            [300, 600],
          ]}
          divId={'div-gpt-ad-topbanner-desktop'}
          pos={['TopBanner']}
        />
      </div>
    </Flex>
  )
  const hasBanner = hasCommunityBanner || hasSponsorBanner

  return (
    <Flex
      gap={24}
      mb={24}
      direction={isMobile || !hasBanner ? 'column' : 'row'}
      justify={!hasArticlesSection ? 'center' : 'flex-start'}
      align={!hasBanner ? 'center' : 'flex-start'}
      id={DueDateNavResultTarget.guide_and_support}
      pt={isMobile ? 0 : 64}
    >
      {!hasBanner && renderedAdsAndCommunitySection}
      {hasArticlesSection && (
        <GuideAndSupportArticles
          colWidth={!hasBanner ? '100%' : undefined}
          suggestedArticles={suggestedArticles}
          titleArticle={titleArticle}
          descriptionArticle={descriptionArticle}
        />
      )}
      {hasBanner && renderedAdsAndCommunitySection}
    </Flex>
  )
}

export default GuideAndSupport
